export const name = 'Tedious';
